var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_2181",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_2181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.2501 17.2125V15.7125C6.6876 15.5375 5.34697 14.8907 4.22822 13.7719C3.10947 12.6532 2.4626 11.3125 2.2876 9.75004H0.787598V8.25004H2.2876C2.4626 6.68754 3.10947 5.34691 4.22822 4.22816C5.34697 3.10941 6.6876 2.46254 8.2501 2.28754V0.787537H9.7501V2.28754C11.3126 2.46254 12.6532 3.10941 13.772 4.22816C14.8907 5.34691 15.5376 6.68754 15.7126 8.25004H17.2126V9.75004H15.7126C15.5376 11.3125 14.8907 12.6532 13.772 13.7719C12.6532 14.8907 11.3126 15.5375 9.7501 15.7125V17.2125H8.2501ZM9.0001 14.25C10.4501 14.25 11.6876 13.7375 12.7126 12.7125C13.7376 11.6875 14.2501 10.45 14.2501 9.00004C14.2501 7.55004 13.7376 6.31254 12.7126 5.28754C11.6876 4.26254 10.4501 3.75004 9.0001 3.75004C7.5501 3.75004 6.3126 4.26254 5.2876 5.28754C4.2626 6.31254 3.7501 7.55004 3.7501 9.00004C3.7501 10.45 4.2626 11.6875 5.2876 12.7125C6.3126 13.7375 7.5501 14.25 9.0001 14.25ZM9.0001 12C8.1751 12 7.46885 11.7063 6.88135 11.1188C6.29385 10.5313 6.0001 9.82504 6.0001 9.00004C6.0001 8.17504 6.29385 7.46879 6.88135 6.88129C7.46885 6.29379 8.1751 6.00004 9.0001 6.00004C9.8251 6.00004 10.5313 6.29379 11.1188 6.88129C11.7063 7.46879 12.0001 8.17504 12.0001 9.00004C12.0001 9.82504 11.7063 10.5313 11.1188 11.1188C10.5313 11.7063 9.8251 12 9.0001 12ZM9.0001 10.5C9.4126 10.5 9.76572 10.3532 10.0595 10.0594C10.3532 9.76566 10.5001 9.41254 10.5001 9.00004C10.5001 8.58754 10.3532 8.23441 10.0595 7.94066C9.76572 7.64691 9.4126 7.50004 9.0001 7.50004C8.5876 7.50004 8.23447 7.64691 7.94072 7.94066C7.64697 8.23441 7.5001 8.58754 7.5001 9.00004C7.5001 9.41254 7.64697 9.76566 7.94072 10.0594C8.23447 10.3532 8.5876 10.5 9.0001 10.5Z",
    fill: "#262261"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyLocation);
export default __webpack_public_path__ + "static/media/my_location.58be73803b949ddba09c09b7b7f78f1b.svg";
export { ForwardRef as ReactComponent };